<template>
<div class="nav">
    <div class="pages">
        <router-link to="/">
          <h3>Login</h3>
        </router-link>
    </div>
</div>


</template>
<script>
import auth from '@/app/auth';
import UserInfoStore from '@/app/user-info-store';

export default {
    mounted: function(){
//      console.log("In LogoutSuccess")
    },
    created: function(){
        if (!UserInfoStore.state.userGroup) {
            auth.login();
        }
    }
}
</script>
